export enum IntegrationDetailsPanelEvents {
  SENSOR_SET_ENABLED_STATUS_ACTION = 'sensor_set_enabled_status_action',
  SET_ENABLED_STATUS_ACTION = 'set_enabled_status_action',
  DELETE_ACTION = 'delete_action',
  EDIT_ACTION = 'edit_action',
  BUTTON_CLICKED_DELETE_SENSOR = 'button_clicked_delete_sensor',
}
